import { render, staticRenderFns } from "./BoxContainer.vue?vue&type=template&id=3d3108ba&scoped=true&"
import script from "./BoxContainer.vue?vue&type=script&lang=ts&"
export * from "./BoxContainer.vue?vue&type=script&lang=ts&"
import style0 from "./BoxContainer.vue?vue&type=style&index=0&id=3d3108ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3108ba",
  null
  
)

export default component.exports